//#region IMPORTS
import { PencilSquareIcon } from "@heroicons/react/24/outline";
import { InstoreTemplate } from "../../models/instoreTemplate";
import { Fragment } from "react";
import { Tooltip } from "react-tooltip";
//#endregion

//#region INTERFACE
interface Props {
  instoreTemplate: InstoreTemplate;
  editHandler: () => void;
}
//#endregion

export default function InstoreTemplatesTableRowActionEdit({
  instoreTemplate,
  editHandler,
}: Props) {
  //#region RENDER
  return (
    <Fragment>
      <button
        data-tooltip-content="Edit instore template"
        data-tooltip-variant="warning"
        data-tooltip-place="right"
        data-tooltip-id={String(instoreTemplate.id) + "edit"}
        data-tooltip-delay-show={500}
        className="flex items-center gap-4"
      >
        <PencilSquareIcon
          className="w-5 h-5 text-amber-500 hover:text-amber-400"
          onClick={editHandler}
          type="button"
        />
      </button>
      <Tooltip id={String(instoreTemplate.id) + "edit"} className="font-bold" />
    </Fragment>
  );
  //#endregion
}
